import * as yup from 'yup';

export const amountSchema = {
  amount: yup
    .number()
    .nullable()
    .transform((value, originalValue) => (originalValue === '' ? null : value))
    .when('amountCheckbox', {
      is: (val) => val === false,
      then: yup
        .number()
        .nullable()
        .transform((value, originalValue) => null),
    }),
};

export const riskScoreSchema = {
  fraud_score_min: yup
    .number()
    .nullable()
    .transform((value, originalValue) => (originalValue === '' ? null : value))
    .when('fraudCheckbox', {
      is: (val) => val === false,
      then: yup
        .number()
        .nullable()
        .transform((value, originalValue) => null),
    }),
  fraud_score_max: yup
    .number()
    .nullable()
    .transform((value, originalValue) => (originalValue === '' ? null : value))
    .when('fraudCheckbox', {
      is: (val) => val === false,
      then: yup
        .number()
        .nullable()
        .transform((value, originalValue) => null),
    }),
};

export const multiSelectValidation = (fieldName) =>
  yup
    .bool()
    .nullable()
    .when(fieldName, {
      is: (val) => val === false,
      then: yup.bool().transform((value, originalValue) => false),
    });
